import { createMultiStyleConfigHelpers } from '@chakra-ui/react'

export const flightItineraryHelpers = createMultiStyleConfigHelpers([
  'title',
  'departureDateTime',
  'airportName',
  'terminal',
  'iataCode',
  'flightTime',
  'arrowWrapper',
  'arrow',
  'stopCount',
  'layoverInfo',
  'directIndicator',
  'journeyDurationInHoursAndMinutes',
  'flightClassesAndFlightNumbers',
])

export const FlightItineraryProp = flightItineraryHelpers.defineMultiStyleConfig({
  baseStyle: flightItineraryHelpers.definePartsStyle({
    arrowWrapper: {
      display: 'flex',
      columnGap: 2,
      flexDir: 'row',
      pb: '3px',
      alignItems: 'center',
      w: '100%',
    },
    arrow: {
      display: 'inline-block',
      width: '100%',
      height: '1px',
      borderTop: '1px solid',
      position: 'relative',

      '&[data-arrow-head=true]': {
        _after: {
          content: '""',
          position: 'absolute',
          top: '50%',
          right: '0',
          transform: 'translateY(-55%) rotate(-45deg)',
          width: '6px',
          height: '6px',
          borderRight: '1px solid',
          borderBottom: '1px solid',
          background: 'transparent',
          display: 'block',
          borderColor: 'inherit',
        },
      },
    },
  }),
})
